"use client"

import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { ChevronDown } from "lucide-react"
import * as React from "react"

import * as styles from "./accordion.styled"

const Accordion = AccordionPrimitive.Root

const AccordionItem = React.forwardRef<
  React.ComponentRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={styles.accordionItem(className)} {...props} />
))
AccordionItem.displayName = "AccordionItem"

const AccordionTrigger = React.forwardRef<
  React.ComponentRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
    Icon?: React.ReactNode
    Avatar?: React.ReactNode
    description?: string
  }
>(({ className, Icon, Avatar, description, children, ...props }, ref) => (
  <AccordionPrimitive.Header className={styles.accordionHeader}>
    <AccordionPrimitive.Trigger ref={ref} className={styles.accordionTrigger(className)} {...props}>
      {Icon ? Icon : null}
      {Avatar ? Avatar : null}
      <div className={styles.accordionTriggerTextContainer}>
        {children}
        {description ? <p className={styles.accordionTriggerDescription}>{description}</p> : null}
      </div>
      <ChevronDown color="#776E77" className={styles.chevronDown} />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef<
  React.ComponentRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content ref={ref} className={styles.accordionContent(className)} {...props}>
    {children}
  </AccordionPrimitive.Content>
))
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger }
